import { render, staticRenderFns } from "./EnvironmentSticker.vue?vue&type=template&id=38f80845&scoped=true&"
import script from "./EnvironmentSticker.vue?vue&type=script&lang=js&"
export * from "./EnvironmentSticker.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentSticker.vue?vue&type=style&index=0&id=38f80845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f80845",
  null
  
)

export default component.exports